<template>
  <section class="invoice-preview-wrapper">
    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="invoiceData === undefined"
      v-if="!refundQueue"
    >
      <h4 class="alert-heading">
        Error fetching Refund Queue
      </h4>
      <div class="alert-body">
        <b-link class="alert-link" :to="{ name: 'myrefund-index' }">
          Go Back
        </b-link>
        to Refund Queue And Try again.
      </div>
    </b-alert>
    <div v-if="refundQueue">
      <div class="mb-1">
        <b-link :to="{ name: 'myrefund-index' }">
          <feather-icon icon="ArrowLeftIcon" />
          <span class="align-middle ml-50">Back to List</span>
        </b-link>
      </div>
      <b-row class="invoice-preview">
        <!-- Col: Left (Invoice Container) -->
        <b-col>
          <b-card no-body class="invoice-preview-card">
            <!-- Header -->
            <b-card-body class="invoice-padding pb-0">
              <div
                class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
              >
                <!-- Header: Left Content -->

                <div>
                  <h4 class="my-2 text-primary">
                    Payment Detail
                  </h4>
                  <h5>
                    Custom Order Code :
                    <span class="invoice-number">{{
                      refundQueue.customOrderCode
                    }}</span>
                  </h5>
                  <hr class="invoice-spacing" />

                  <h5>
                    Fly Gate OrderId :
                    <span class="invoice-number">{{
                      refundQueue.flyGateOrderId
                    }}</span>
                  </h5>
                  <hr class="invoice-spacing" />

                  <h5>
                    Order Amount :
                    <span pill variant="primary">{{
                      refundQueue.orderAmount
                    }}</span>
                  </h5>
                  <hr class="invoice-spacing" />

                  <h5>
                    vendor TxnRef. Number :
                    <span pill variant="primary">{{
                      refundQueue.vendorTxnRefNumber
                    }}</span>
                  </h5>
                  <hr class="invoice-spacing" />

                  <h5>
                    Paid FOP :
                    <span pill variant="primary">{{
                      refundQueue.paidFOP
                    }}</span>
                  </h5>
                  <hr class="invoice-spacing" />

                  <h5>
                    Paid Date :
                    <span pill variant="primary">{{
                      refundQueue.paidDate
                    }}</span>
                  </h5>
                </div>
                <!-- <div class="mt-md-0 mt-2">
                <div class="invoice-date-wrapper">
                  <p class="invoice-date">
                    Request Date:  {{ row.refundRequestedDateTime }}

                  </p>
                </div>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date">
                    Due Date: {{ row.expiryDate }}
                  </p>
                </div>
              </div> -->
                <div>
                  <h4 class="my-2 text-primary">
                    Refund Detail
                  </h4>
                  <h5>
                    Refund Reference Code :
                    <span class="invoice-number">{{
                      refundQueue.refundReferenceCode
                    }}</span>
                  </h5>
                  <hr class="invoice-spacing" />

                  <h5>
                    Refund Merchant RequestCode :
                    <span class="invoice-number">{{
                      refundQueue.refundMerchantRequestCode
                    }}</span>
                  </h5>
                  <hr class="invoice-spacing" />

                  <h5>
                    Ticket Number :
                    <span class="invoice-number">{{
                      refundQueue.originalTicketNumber
                    }}</span>
                  </h5>
                  <hr class="invoice-spacing" />

                  <h5>
                    Refund Amount :
                    <span class="invoice-number">{{
                      refundQueue.refundRequestedAmount
                    }}</span>
                  </h5>
                  <hr class="invoice-spacing" />

                  <h5>
                    Refund Requested Date :
                    <span class="invoice-number text-black">{{
                      refundQueue.refundRequestedDateString
                    }}</span>
                  </h5>
                  <hr class="invoice-spacing" />

                  <h5>
                    Refund status :
                    <b-badge pill variant="warning">{{
                      refundStatusOptions.filter(
                        (f) => f.value == refundQueue.refundStatus
                      )[0].text
                    }}</b-badge>
                  </h5>
                </div>
                <div>
                  <h4 class="mb-2 text-primary">
                    Personal Detail:
                  </h4>
                  <h5>
                    Name :
                    <span>
                      {{ refundQueue.firstName }}
                      {{ refundQueue.lastName }}
                    </span>
                  </h5>
                  <h5>
                    Email :
                    <span>{{ refundQueue.email }}</span>
                  </h5>
                </div>
              </div>
            </b-card-body>

            <!-- Spacer -->

            <!-- Invoice Client & Payment Details -->

            <b-row class="invoice-spacing">
              <!-- Col: Invoice To -->

              <b-col>
                <b-card>
                  <!-- Button: Add Payment -->
                  <b-button
                    v-b-toggle.sidebar-invoice-add-payment
                    v-ripple="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="mb-75"
                    block
                  >
                    Approve
                  </b-button>

                  <!-- Button: Send Invoice -->
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-toggle.sidebar-send-invoice
                    variant="danger"
                    class="mb-75"
                    block
                  >
                    Reject
                  </b-button>
                </b-card>
              </b-col>
            </b-row>

            <!-- Spacer -->
            <hr class="invoice-spacing" />
            <!-- Note -->
            <!-- <b-card-body class="invoice-padding pt-0">
            <span class="font-weight-bold">Note: </span>
            <span
              >It was a pleasure working with you and your team. We hope you
              will keep us in mind for future freelance projects. Thank
              You!</span
            >
          </b-card-body> -->
          </b-card>
        </b-col>

        <!-- Right Col: Card -->
        <!-- <b-col cols="12" md="4" xl="3" class="invoice-actions"> </b-col> -->
        <!-- loadings -->
        <b-overlay :show="isLoading" no-wrap rounded="sm" />
      </b-row>
    </div>
    <b-row>
      <b-table responsive="sm" :items="row.orderRefundWorkFlowHistories" />
    </b-row>
    <InvoiceSidebarSendInvoice :info="refundQueue" />
    <InvoiceSidebarAddPayment :info="refundQueue" />
  </section>
</template>

<script>
import { ref, onUnmounted } from "@vue/composition-api";
import store from "@/store";
import {
  BRow,
  BOverlay,
  BBadge,
  BTable,
  BCol,
  BCard,
  BCardBody,
  BButton,
  VBToggle,
  BLink,
} from "bootstrap-vue";
import axios from "@axios";

import Ripple from "vue-ripple-directive";
import invoiceStoreModule from "../invoiceStoreModule";
import InvoiceSidebarSendInvoice from "./reject.vue";
import InvoiceSidebarAddPayment from "./Approve.vue";

export default {
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTable,
    BButton,
    BOverlay,
    BBadge,
    InvoiceSidebarAddPayment,
    InvoiceSidebarSendInvoice,
    BLink,
  },
  props: {
    refundQueue: {
      type: Object,
    },
  },
  data() {
    const invoiceData = ref(null);
    const paymentDetails = ref({});
    // Invoice Description
    // ? Your real data will contain this information
    const invoiceDescription = [
      {
        taskTitle: "Native App Development",
        taskDescription:
          "Developed a full stack native app using React Native, Bootstrap & Python",
        rate: "$60.00",
        hours: "30",
        total: "$1,800.00",
      },
      {
        taskTitle: "UI Kit Design",
        taskDescription:
          "Designed a UI kit for native app using Sketch, Figma & Adobe XD",
        rate: "$60.00",
        hours: "20",
        total: "$1200.00",
      },
    ];

    const INVOICE_APP_STORE_MODULE_NAME = "app-invoice";

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME))
      store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule);

    invoiceData.value = invoiceDescription;
    paymentDetails.value = paymentDetails;

    const printInvoice = () => {
      window.print();
    };

    return {
      invoiceData,
      paymentDetails,
      invoiceDescription,
      printInvoice,
      row: [],
      isLoading: false,
      formData: {
        orderId: 0,
        action: 2,
        remark: "",
      },
      refundStatusOptions: [
        { value: "0", text: "NotRequested" },
        { value: "1", text: "Pending" },
        { value: "2", text: "Submitted" },
        { value: "3", text: "Approved" },
        { value: "4", text: "Sent" },
        { value: "5", text: "Rejected" },
        { value: "6", text: "Completed" },
      ],
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {
  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
</style>
